function isNavigationTiming(
  entry: PerformanceEntry,
): entry is PerformanceNavigationTiming {
  return (
    typeof PerformanceNavigationTiming !== "undefined" &&
    entry instanceof PerformanceNavigationTiming
  );
}

export function readDocumentServerTiming(): readonly PerformanceServerTiming[] {
  if (
    typeof performance === "undefined" ||
    typeof performance.getEntriesByType !== "function"
  ) {
    return [];
  }
  const [navigation] = performance.getEntriesByType("navigation");
  if (!navigation || !isNavigationTiming(navigation)) return [];
  return navigation.serverTiming;
}
